export const SUPPORTED_COUNTRY_CODES = [
    'BG',
    'US',
    'GB',
    'DE',
    'FR',
    'ES',
    'IT',
    'NL',
    'PL',
    'RO',
    'CA',
    'AU'
];

export function inferCountryFromTimezone(tz) {
    if (!tz) return null;
    const tzLower = tz.toLowerCase();
    if (tzLower === 'europe/sofia') return 'BG';
    if (tzLower === 'europe/london' || tzLower === 'europe/belfast') return 'GB';
    if (tzLower === 'europe/berlin' || tzLower === 'europe/busingen') return 'DE';
    if (tzLower === 'europe/paris') return 'FR';
    if (tzLower === 'europe/madrid' || tzLower === 'atlantic/canary' || tzLower === 'africa/ceuta') return 'ES';
    if (tzLower === 'europe/rome') return 'IT';
    if (tzLower === 'europe/amsterdam') return 'NL';
    if (tzLower === 'europe/warsaw') return 'PL';
    if (tzLower === 'europe/bucharest') return 'RO';
    if (tzLower.startsWith('australia/')) return 'AU';
    if (tzLower.startsWith('canada/') ||
        ['america/toronto', 'america/vancouver', 'america/montreal', 'america/edmonton',
         'america/winnipeg', 'america/halifax', 'america/st_johns', 'america/regina'].includes(tzLower)) {
        return 'CA';
    }
    if (tzLower.startsWith('us/') ||
        ['america/new_york', 'america/chicago', 'america/denver', 'america/los_angeles',
         'america/phoenix', 'america/detroit', 'america/boise', 'america/anchorage',
         'america/adak', 'america/indiana/indianapolis', 'pacific/honolulu'].includes(tzLower)) {
        return 'US';
    }
    return null;
}

export function detectUserLocale(fallbackCountry = 'BG') {
    let detectedTz = 'UTC';
    if (typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
        try {
            detectedTz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
        } catch (e) {
            // ignore
        }
    }

    let detectedCountry = inferCountryFromTimezone(detectedTz);

    if (!detectedCountry && typeof navigator !== 'undefined' && navigator.language) {
        const langParts = navigator.language.split('-');
        if (langParts.length > 1) {
            const candidate = langParts[1].toUpperCase();
            if (SUPPORTED_COUNTRY_CODES.includes(candidate)) {
                detectedCountry = candidate;
            }
        } else if (navigator.language.toLowerCase().startsWith('bg')) {
            detectedCountry = 'BG';
        }
    }

    if (!detectedCountry) {
        detectedCountry = fallbackCountry;
    }

    return {
        countryCode: detectedCountry,
        timezone: detectedTz
    };
}
